import { render, staticRenderFns } from "./comDtoData1.vue?vue&type=template&id=5499e8ea&scoped=true&"
import script from "./comDtoData1.vue?vue&type=script&lang=js&"
export * from "./comDtoData1.vue?vue&type=script&lang=js&"
import style0 from "./comDtoData1.vue?vue&type=style&index=0&id=5499e8ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499e8ea",
  null
  
)

export default component.exports